import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import KargoKuryeTakipAramaKriterleri, { KargoKuryeTakipDetayAramaKriterleri } from "./KargoKuryeTakipAramaKriterleri";
import VwKargokuryetakip1DTO from "src/models/KargoKuryeTakip/VwKargokuryetakip1DTO";
import VwKargokuryetakip2DTO from "src/models/KargoKuryeTakip/VwKargokuryetakip2DTO";

interface IKargoKuryeTakip {
    searchHandler?: boolean;
    aramaKriterleri?: KargoKuryeTakipAramaKriterleri;
    open?: boolean;
    activeRow?: VwKargokuryetakip1DTO;

    detayAramaKriterleri?: KargoKuryeTakipDetayAramaKriterleri;
    detayActiveRow?: VwKargokuryetakip2DTO;
    detaySearchHandler?: boolean;
};

export const KargoKuryeTakipSlice = createSlice<IKargoKuryeTakip, MapReducerPayloads<IKargoKuryeTakip, {
    setSearchHandler?: boolean;
    setAramaKriterleri?: KargoKuryeTakipAramaKriterleri;
    setOpen?: boolean;
    setActiveRow?: VwKargokuryetakip1DTO;

    setDetayAramaKriterleri?: KargoKuryeTakipDetayAramaKriterleri;
    setDetayActiveRow?: VwKargokuryetakip2DTO;
    setDetaySearchHandler?: boolean;
}>>({
    name: "kargoKuryeTakip",
    initialState: {
        searchHandler: false,
        aramaKriterleri: new KargoKuryeTakipAramaKriterleri(),
        open: false,
        activeRow: new VwKargokuryetakip1DTO(),

        detayAramaKriterleri: new KargoKuryeTakipDetayAramaKriterleri(),
        detayActiveRow: new VwKargokuryetakip2DTO(),
        detaySearchHandler: false
    },
    reducers: {
        /**
         * Kargo kurye takip ekranı bilgileri
         * Arama kriterleri = endpoint request
         * activeRow = formik işlemleri
         * open = Kayıt ekleme güncelleme
         * searchHandler useEffect ile tetiklenip query sorgusunu çalıştırır
         * @param state 
         * @param action 
        */
        setSearchHandler: (state, action) => {
            state.searchHandler = action.payload
        },
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },

        /**
         * Kargo kurye takip ekranı kaydın detay statelerinin tutulduğu bölüm
         * Arama kriterleri endpoint request
         * activeRow formik işlemleri
         * @param state 
         * @param action 
        */
        setDetayAramaKriterleri: (state, action) => {
            state.detayAramaKriterleri = action.payload
        },
        setDetayActiveRow: (state, action) => {
            state.detayActiveRow = action.payload
        },
        setDetaySearchHandler: (state, action) => {
            state.detaySearchHandler = action.payload
        }
    }
});